var map = {
	"./": 461,
	"./development": 1387,
	"./development.js": 1387,
	"./index": 461,
	"./index.js": 461,
	"./preprod": 1388,
	"./preprod.js": 1388,
	"./production": 1368,
	"./production.js": 1368,
	"./staging": 1389,
	"./staging.js": 1389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3367;